import { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { login, error, loading } = useAuth();
  const [phone, setPhone] = useState('');
  const [localError, setLocalError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLocalError('');
    if (!phone.trim()) {
      setLocalError('Please enter your phone number');
      return;
    }
    try {
      await login(phone);
    } catch (err: any) {
      setLocalError(err.message);
    }
  };

  const formatInput = (value: string) => {
    const digits = value.replace(/\D/g, '');
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 bg-gradient-to-b from-practice/5 to-white dark:from-gray-900 dark:to-gray-950">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-practice rounded-2xl mb-4 shadow-lg">
            <span className="text-3xl font-bold text-white">CP</span>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">CrewPool</h1>
          <p className="text-gray-500 dark:text-gray-400 mt-2">Carpool coordination made simple</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="phone" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
              Phone Number
            </label>
            <input
              id="phone"
              type="tel"
              inputMode="numeric"
              autoComplete="tel"
              placeholder="(555) 123-4567"
              value={phone}
              onChange={(e) => setPhone(formatInput(e.target.value))}
              className="w-full px-4 py-3.5 text-lg rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-400 focus:ring-2 focus:ring-practice focus:border-transparent outline-none transition"
            />
          </div>

          {(localError || error) && (
            <p className="text-sm text-cancelled font-medium px-1">{localError || error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3.5 px-4 text-lg font-semibold text-white bg-practice hover:bg-practice-dark rounded-xl shadow-sm transition-colors disabled:opacity-50 min-h-tap"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p className="text-center text-sm text-gray-400 dark:text-gray-500 mt-8">
          Don't have access? Contact your group admin.
        </p>
      </div>
    </div>
  );
}
